import { render, staticRenderFns } from "./refund-detail.vue?vue&type=template&id=f275d2b0&scoped=true&"
import script from "./refund-detail.vue?vue&type=script&lang=js&"
export * from "./refund-detail.vue?vue&type=script&lang=js&"
import style0 from "./refund-detail.vue?vue&type=style&index=0&id=f275d2b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f275d2b0",
  null
  
)

export default component.exports